/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { ActivatedRoute, Router } from '@angular/router';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../core/services/app-utility.service';
import { BaseResponse } from './../../core/model/base-response.model';
import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from './../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../core/services/lms-logger.service';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { LocoDetail } from './../../core/model/loco-detail.model';
import { MenuItem } from '../../core/model/menu-item.model';
import { MessageHandlerService } from './../../core/services/message-handler.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { StaticDataStoreService } from './../../core/services/static-datastore.service';
import { TabSearchParameter } from '../../core/model/tab-search-parameter.model';
import { TerminalConfigService } from './../shared/services/terminal-config.service';
import { TerminalHandlingInbound } from './../../terminal/shared/model/terminal-handling-inbound.model';
import { TerminalHandlingInboundDisplay } from './../shared/model/terminal-handling-inbound-display.model';
import { TerminalHandlingLocoInfo } from './../../core/model/terminal-handling-loco-info.model';
import { TerminalHandlingOnTerminal } from './../../terminal/shared/model/terminal-handling-on-terminal.model';
import { TerminalHandlingOnTerminalDisplay } from './../shared/model/terminal-handling-onterminal-display.model';
import { TerminalHandlingService } from './../shared/services/terminal-handling.service';
import { TerminalHandlingUpdateRequest } from './../../core/model/terminal-handling-update-request-model';
import { UtilService } from './../../core/services/util.service';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class LmsTerminalHandlingComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-terminal-handling',
  templateUrl: './terminal-handling.component.html',
  styleUrls: ['./terminal-handling.component.scss']
})
@PermitAll()
export class LmsTerminalHandlingComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  messages: any;
  terminalHandlingSearchText: string;
  isShowTerminalPlan: boolean;
  loco: LocoDetail;
  searchTerminalMenmonic: string;
  searchTerminalCityState: string;
  thpPlan: string;
  terminalHandlingInbounds?: Array<TerminalHandlingInbound>;
  terminalHandlingOnTerminals?: Array<TerminalHandlingOnTerminal>;
  totalOnTerminalLocomotivesArr: Array<TerminalHandlingOnTerminalDisplay>;
  totalInboundTrainsArr: Array<TerminalHandlingInboundDisplay>;
  responseHeader: BaseResponse;
  isUpdateThp: boolean;
  mileposts: Array<string> = [];
  mnemonics: Array<string> = [];
  filteredResults: Array<string> = [];
  popupErrorMessage: string;
  errorDialog = false;
  popupServiceSubscription: any;
  terminalHandlingSub: any;
  windowCode = 'LWTW';

  overlayPanel: OverlayPanel;
  panelVisible = false;
  terminalLinks: Array<MenuItem>;
  trainLinks: Array<MenuItem>;
  overlayLinks: Array<MenuItem>;
  contextMenuValue: string;
  contextMenuType: string;

  private TRAIN_TYPE = 'TRAIN';
  private TERMINAL_TYPE = 'TERMINAL';
  private TRAIN_ID = 'trainId';
  private PREVIOUS_ASSIGNMENT = 'previousAssignment';
  private COMMON_PICKLIST = 'commonopsPicklist';

  /**
   * Creates an instance of LmsTerminalHandlingComponent.
   * @param {LmsModuleService} lmsModuleService
   * @param {LmsMenuService} lmsMenuService
   * @param {ConfigService} configService
   * @param {TerminalHandlingService} terminalHandlingService
   * @param {TerminalConfigService} terminalConfigService
   * @param {UtilService} utilService
   * @param {Router} router
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {MessageHandlerService} messageHandlerService
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {ActivatedRoute} route
   * @param {PopupService} popupService
   * @param {LmsLoaderService} lmsLoaderService
   * @param {AppUtilityService} appUtilityService
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  constructor(lmsModuleService: LmsModuleService,
    lmsMenuService: LmsMenuService,
    configService: ConfigService,
    private terminalHandlingService: TerminalHandlingService,
    private terminalConfigService: TerminalConfigService,
    utilService: UtilService,
    private router: Router,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    private messageHandlerService: MessageHandlerService,
    private staticDataStoreService: StaticDataStoreService,
    private route: ActivatedRoute,
    popupService: PopupService,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService, private lmsLoggerService: LmsLoggerService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.messages = this.terminalConfigService.terminalConfigData.messages;
    this.service = terminalHandlingService;
    this.type = this.configService.getConfigData().menu.type.terminal;
    this.popupServiceSubscription = this.popupService.successObservable.subscribe((data) => {
      if (data && data.action && data.action === true) {
        this.checkSuccessOperation(data.message);
      }
    });
    this.terminalLinks = this.lmsMenuService.getMenuItem('Terminal').subTypes;
    this.trainLinks = this.lmsMenuService.getMenuItem('Train').subTypes;
  }

  /**
   * @private
   * @param {any} message
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  private checkSuccessOperation(message) {
    this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
    this.terminalHandlingService.load(this.selectedTab,
      true, message);
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTerminalHandlingComponent
   */
  ngOnInit() {
    super.init(this.search);
    this.terminalHandlingSub = this.terminalHandlingService.loadData.subscribe(data => {
      const windowHeight = window.innerHeight;
      let heightToAdjust = 0;
      if (window.innerWidth < 1280) {
        heightToAdjust = 22;
      }
      const leftMenuItems = document.getElementById('leftMenuItems');
      leftMenuItems.removeAttribute('style');
      if (windowHeight && leftMenuItems) {
        leftMenuItems.removeAttribute('style');
        leftMenuItems.style.maxHeight = (windowHeight) + 'px';
        leftMenuItems.style.minHeight = ' ' + (windowHeight - 36 - heightToAdjust) + 'px';
      }
      this.setThpInboundOnTerminalData(data);
    });
  }

  /**
  * This is used to search TerminalHandling
  * @memberOf LmsTerminalHandlingComponent
  */
  search() {
    // clear the filter when click on global search button.
    if (!this.isUpdateThp) {
      const thpClearBtn = document.getElementById('thpClearBtn');
      if (thpClearBtn) {
        thpClearBtn.click();
      }
      this.isUpdateThp = false;
    }
    if (this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status === 'refresh') {
      this.selectedTab.openState = { headerName: '', status: null, activeStatus: false, collpase: null };
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }
    this.terminalHandlingService.load(this.selectedTab);
  }
  /**
   * set serach text for filter on inbound and on-terminal sections.
   *
   * @param {string} event
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  updateupdateTHPSearchText(event: string) {
    this.terminalHandlingSearchText = event ? event.trim().toUpperCase() : event;
  }
  /**
   * Shows locoMotive Context MEnu
   * @param {any} event
   * @memberOf LmsTerminalHandlingComponent
   */
  public showLocomotiveContextMenu(event) {
    this.hideContextMenuChild();
    this.popupService.getLocomotiveInformation(this.appUtilityService.formatLocomotiveId(event.loco.locomotiveIdentifier)).subscribe((data: any) => {
      if (data && data.priorityCode) {
        const pCode = parseInt(data.priorityCode, 10);
        if (pCode >= 1 && pCode <= 4) {
          this.selectedLoco = <LocoDetail>this.popupService.getLocoDetailObj(data.locoStatusList, event.loco.locomotiveIdentifier);
          if (this.selectedLoco) {
            this.selectedLocoId = 'loco' + this.appUtilityService.formatLocomotiveIdForDispaly(event.loco.locomotiveIdentifier) + event.index;
            this.selectedLoco.renderContextMenu = true;
          } else {
            this.selectedLoco = <LocoDetail>{};
            this.selectedLoco.renderContextMenu = true;
            this.selectedLocoId = 'loco' + this.appUtilityService.formatLocomotiveIdForDispaly(event.loco.locomotiveIdentifier) + event.index;
          }
          this.lmsLoaderService.hideLoader();
        } else {
          this.selectedTab.subTypeDetail.handling.message = data.messageText;
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
          this.lmsLoaderService.hideLoader();
        }
      }
    },
      (error) => {
        this.selectedTab.subTypeDetail.handling.message = this.appUtilityService.getHttpErroMessage(error, false);
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
        this.lmsLoaderService.hideLoader();
      });
  }

  /**
     * this method is used to hide the context panel of locomotive
     * which comes in open state when user right click on locomotive
     * svg icon
     * @memberOf LmsTerminalHandlingComponent
     */
  @HostListener('document:click') hideContextMenuChild() {
    super.hideContextMenu('host');
    if (this.overlayPanel && this.overlayPanel.overlayVisible) {
      this.checkForOverlayPanelVisibility();
    }
  }

  /**
   * Show update terminal handling popup.
   *
   * @param {any} event
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  showUpdateThpPopup(event) {

  }

  /**
   * Cancel operation for update terminal handling plan.
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  cancelThpOperation() {
    this.isShowTerminalPlan = false;
  }

  /**
   * Set locomotive array as per inbound and on-terminal section.
   * @memberOf LmsTerminalHandlingComponent
   */
  setThpInboundOnTerminalData(data: any) {
    if (data && data.locoInfoList) {
      this.convertLocoInfoList(data.locoInfoList);
    }
  }

  /**
   * Convert locomotive array as per inbound and on-terminal section.
   *
   * @param {Array<TerminalHandlingLocoInfo>} locoInfoList
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  convertLocoInfoList(locoInfoList: Array<TerminalHandlingLocoInfo>) {
    this.terminalHandlingInbounds = [];
    this.terminalHandlingOnTerminals = [];

    const thpInboundLocoArray = this.getFilteredLocoObjArr(locoInfoList, this.TRAIN_TYPE);
    if (thpInboundLocoArray) {
      this.setThpInboundArr(thpInboundLocoArray);
    }
    const thpOnTerminalLocoArray = this.getFilteredLocoObjArr(locoInfoList, this.TERMINAL_TYPE);
    if (thpOnTerminalLocoArray) {
      this.setThpOnTerminalArr(thpOnTerminalLocoArray);
    }

  }

  /**
   * Set terminal handling inbound array from terminal handling locoinfo array.
   *
   * @param {Array<TerminalHandlingLocoInfo>} thpInboundLocoArray
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  setThpInboundArr(thpInboundLocoArray: Array<TerminalHandlingLocoInfo>) {
    thpInboundLocoArray.map(locoInfoObj => {
      let changedBy = '';
      let projectedDeparture = '';
      let inbndTrainETA = '';
      let intendedUsageCode = '';

      changedBy = this.getChangeByDetail(locoInfoObj);
      projectedDeparture = this.getProjectDeparture(locoInfoObj);
      inbndTrainETA = this.getInboundTrainETA(locoInfoObj);
      if (locoInfoObj.intendedUsageCode) {
        intendedUsageCode = this.appUtilityService.getIntendedUsageShortDesc(locoInfoObj.intendedUsageCode);
      }


      const terminalHandlingInbound = {
        trainId: locoInfoObj.currAssignDetail,
        locomotiveId: locoInfoObj.locoInit.trim() + ' ' + locoInfoObj.locoNumber.trim().replace(/^0+/, ''),
        thpTypeCode: locoInfoObj.thpTypeCode,
        terminalHandlingPlan: locoInfoObj.thpTypeDesc,
        changedBy: changedBy,
        userName: locoInfoObj.userName,
        plannedAssignment: locoInfoObj.planAssignDetail,
        projectedDeparture: projectedDeparture,
        previousPlan: locoInfoObj.prevTHPTypeDesc,
        inboundTrainETA: inbndTrainETA,
        actualLocomotiveId: locoInfoObj.locomotiveID,
        intendedUsageCode: intendedUsageCode
      };
      this.terminalHandlingInbounds.push(terminalHandlingInbound);
    });
    this.convertThpInboundArrToThpInboundDisplayArr(this.terminalHandlingInbounds);
  }
  /**
   * Convert array of terminal handling inbound to terminal handling dispkay for locomotives group.
   *
   * @param {Array<TerminalHandlingInbound>} terminalHandlingInbounds
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  convertThpInboundArrToThpInboundDisplayArr(terminalHandlingInbounds: Array<TerminalHandlingInbound>) {
    this.totalInboundTrainsArr = [];
    if (terminalHandlingInbounds) {
      for (let i = 0; i < this.terminalHandlingInbounds.length; i++) {
        const trainId = terminalHandlingInbounds[i].trainId;
        const locomotiveArr = terminalHandlingInbounds.filter((terminalHandlingInbound) => {
          return terminalHandlingInbound.trainId === trainId;
        });
        const terminalHandlingDisplay = {
          trainId: trainId,
          inboundTrainETA: terminalHandlingInbounds[i].inboundTrainETA,
          locomotiveArr: locomotiveArr
        };
        this.totalInboundTrainsArr.push(terminalHandlingDisplay);
      }
    }
    this.totalInboundTrainsArr = this.removeDuplicates(this.totalInboundTrainsArr, this.TRAIN_ID);

  }
  /**
     * Set terminal handling on-terminal array from terminal handling locoinfo array.
     *
     * @param {Array<TerminalHandlingLocoInfo>} thpOnTerminalLocoArray
     *
     * @memberOf LmsTerminalHandlingComponent
     */
  setThpOnTerminalArr(thpOnTerminalLocoArray: Array<TerminalHandlingLocoInfo>) {
    thpOnTerminalLocoArray.map(locoInfoObj => {

      const changedBy = this.getChangeByDetail(locoInfoObj);
      const resultTs = this.getActualActivityTs(locoInfoObj);
      const projectedDeparture = this.getProjectDeparture(locoInfoObj);
      let intendedUsageCode = '';
      if (locoInfoObj.intendedUsageCode) {
        intendedUsageCode = this.appUtilityService.getIntendedUsageShortDesc(locoInfoObj.intendedUsageCode);
      }

      const terminalHandlingOnTerminal = {
        previousAssignment: locoInfoObj.prevAssignDetail,
        locomotiveId: locoInfoObj.locoInit.trim() + ' ' + locoInfoObj.locoNumber.trim().replace(/^0+/, ''),
        thpTypeCode: locoInfoObj.thpTypeCode,
        terminalHandlingPlan: locoInfoObj.thpTypeDesc,
        changedBy: changedBy,
        userName: locoInfoObj.userName,
        actualActivityDesc: locoInfoObj.thpResultDesc,
        actualActivityTs: resultTs,
        plannedAssignment: locoInfoObj.planAssignDetail,
        projectedDeparture: projectedDeparture,
        previousPlan: locoInfoObj.prevTHPTypeDesc,
        actualLocomotiveId: locoInfoObj.locomotiveID,
        intendedUsageCode: intendedUsageCode
      };
      this.terminalHandlingOnTerminals.push(terminalHandlingOnTerminal);
    });

    this.convertThpOnTerminalArrToThpInboundDisplayArr(this.terminalHandlingOnTerminals);
  }

  /**
   * Convert array of terminal handling onTerminal to terminal handling dispkay for locomotives group.
   *
   * @param {Array<TerminalHandlingOnTerminal>} terminalHandlingOnTerminals
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  convertThpOnTerminalArrToThpInboundDisplayArr(terminalHandlingOnTerminals: Array<TerminalHandlingOnTerminal>) {
    this.totalOnTerminalLocomotivesArr = [];
    if (terminalHandlingOnTerminals) {
      for (let i = 0; i < terminalHandlingOnTerminals.length; i++) {
        const previousAssignment = terminalHandlingOnTerminals[i].previousAssignment;
        const locomotiveArr = terminalHandlingOnTerminals.filter((terminalHandlingOnTerminal) => {
          return terminalHandlingOnTerminal.previousAssignment === previousAssignment;
        });

        const terminalHandlingOnTerminal = {
          previousAssignment: previousAssignment,
          locomotiveArr: locomotiveArr
        };
        this.totalOnTerminalLocomotivesArr.push(terminalHandlingOnTerminal);
      }
      this.totalOnTerminalLocomotivesArr = this.removeDuplicates(this.totalOnTerminalLocomotivesArr, this.PREVIOUS_ASSIGNMENT);
      this.sortOnTerminalArr(this.totalOnTerminalLocomotivesArr);
    }
  }
  /**
   * Remove duplicate object from given array.
   *
   * @param {any} myArr
   * @param {any} prop
   * @returns
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  /**
   * Build request parameters for update terminal handling plan.
   *
   * @returns {TerminalHandlingUpdateRequest}
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  buildUpdateRquest(): TerminalHandlingUpdateRequest {
    const terminalHandlingLocoInfo = {
      locomotiveID: this.appUtilityService.formatLocomotiveId(this.loco.actualLocomotiveId)
    };
    const terminalHandlingLocoInfoArr: Array<TerminalHandlingLocoInfo> = [];
    terminalHandlingLocoInfoArr.push(terminalHandlingLocoInfo);

    const terminalHandlingUpdateRequest = {
      thpTerminal: this.selectedTab.tabSearchParameter.searchText.trim(),
      terminalHandlingType: this.thpPlan,
      otherLocosList: terminalHandlingLocoInfoArr
    };
    return terminalHandlingUpdateRequest;
  }

  /**
   * Invoked when select value from autocomplete.
   *
   * @param {string} value
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  selectValueFromAutoComplete(value: string) {
    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue(this.COMMON_PICKLIST);
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.searchTerminalMenmonic = emitValue;
  }

  /**
   * Terminal mnemonic autocomplete list.
   *
   * @param {any} event
   *
   * @memberOf LmsTerminalHandlingComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    const commonopsPicklist = this.staticDataStoreService.getValue(this.COMMON_PICKLIST);
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));

    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * Sort on terminal array with ascending order of train ID.
   * @param {Array<TerminalHandlingOnTerminalDisplay>} totalOnTerminalLocomotivesArr
   * @returns {Array<TerminalHandlingOnTerminalDisplay>}
   * @memberOf LmsTerminalHandlingComponent
   */
  sortOnTerminalArr(totalOnTerminalLocomotivesArr: Array<TerminalHandlingOnTerminalDisplay>): Array<TerminalHandlingOnTerminalDisplay> {
    this.totalOnTerminalLocomotivesArr = totalOnTerminalLocomotivesArr.filter((terminalHandlingOnTerminalDisplay) => {
      return (this.isTrainId(terminalHandlingOnTerminalDisplay.previousAssignment));
    });

    Array.prototype.push.apply(this.totalOnTerminalLocomotivesArr,
      totalOnTerminalLocomotivesArr.filter((terminalHandlingOnTerminalDisplay) => {
        return (!this.isTrainId(terminalHandlingOnTerminalDisplay.previousAssignment));
      }));

    return this.totalOnTerminalLocomotivesArr;
  }

  /**
   * Check for valid train ID.
   * @param {string} value
   * @returns {boolean}
   * @memberOf LmsTerminalHandlingComponent
   */
  isTrainId(value: string): boolean {
    let flag = false;
    if (value && value.length > 0) {
      if (!this.isNumeric(value.charAt(0))) {
        const remainingStr = value.substring(1, value.length);
        if (this.isNumeric(remainingStr)) {
          flag = true;
        }
      }
    }
    return flag;
  }

  /**
   * Get change by detail.
   * @param {TerminalHandlingLocoInfo} locoInfoObj
   * @returns {string}
   * @memberOf LmsTerminalHandlingComponent
   */
  getChangeByDetail(locoInfoObj: TerminalHandlingLocoInfo): string {
    let updateTs;
    let changedBy;
    if (locoInfoObj && locoInfoObj.thpUpdtTS && locoInfoObj.thpUpdtTS.trim().length > 0) {
      locoInfoObj.thpUpdtTS = locoInfoObj.thpUpdtTS.trim();
      updateTs = locoInfoObj.thpUpdtTS.substring(5, 7) + '/' + locoInfoObj.thpUpdtTS.substring(8, 10) + '/' +
        locoInfoObj.thpUpdtTS.substring(0, 4) + ' ' + locoInfoObj.thpUpdtTS.substring(11, 13) + ':' + locoInfoObj.thpUpdtTS.substring(14, 16);
    }
    if (locoInfoObj && locoInfoObj.thpUpdtUser && updateTs) {
      changedBy = locoInfoObj.thpUpdtUser + ', ' + updateTs;
    } else if (locoInfoObj && locoInfoObj.thpUpdtUser && !updateTs) {
      changedBy = locoInfoObj.thpUpdtUser;
    }
    return changedBy;
  }

  /**
   * Get project departure detail.
   * @param {TerminalHandlingLocoInfo} locoInfoObj
   * @returns {string}
   * @memberOf LmsTerminalHandlingComponent
   */
  getProjectDeparture(locoInfoObj: TerminalHandlingLocoInfo): string {
    let projectedDeparture;
    if (locoInfoObj) {
      projectedDeparture = locoInfoObj.otbndTrainETD;
      if (projectedDeparture && projectedDeparture.trim().length > 0) {
        projectedDeparture = projectedDeparture.trim();
        projectedDeparture = projectedDeparture.substring(5, 7) + '/' + projectedDeparture.substring(8, 10) +
          '/' + projectedDeparture.substring(0, 4) + ' ' + projectedDeparture.substring(11, 13) + ':' +
          projectedDeparture.substring(14, 16);
      }
    }
    return projectedDeparture;
  }

  /**
   * Get Actual Activity ts
   * @param {TerminalHandlingLocoInfo} locoInfoObj
   * @returns {string}
   * @memberOf LmsTerminalHandlingComponent
   */
  getActualActivityTs(locoInfoObj: TerminalHandlingLocoInfo): string {
    let resultTs;
    if (locoInfoObj && locoInfoObj.thpResultTS && locoInfoObj.thpResultTS.trim().length > 0) {
      locoInfoObj.thpResultTS = locoInfoObj.thpResultTS.trim();
      resultTs = locoInfoObj.thpResultTS.substring(5, 7) + '/' + locoInfoObj.thpResultTS.substring(8, 10) + '/' + locoInfoObj.thpResultTS.substring(0, 4) +
        ' ' + locoInfoObj.thpResultTS.substring(11, 13) + ':' + locoInfoObj.thpResultTS.substring(14, 16);
    }
    return resultTs;
  }

  /**
   * Get inbound train ETA
   * @param {TerminalHandlingLocoInfo} locoInfoObj
   * @returns {string}
   * @memberOf LmsTerminalHandlingComponent
   */
  getInboundTrainETA(locoInfoObj: TerminalHandlingLocoInfo): string {
    let inbndTrainETA;
    if (locoInfoObj) {
      inbndTrainETA = locoInfoObj.inbndTrainETA;
      if (inbndTrainETA && inbndTrainETA.length > 0) {
        inbndTrainETA = inbndTrainETA.substring(5, 7) + '/' + inbndTrainETA.substring(8, 10) + '/' + inbndTrainETA.substring(0, 4) +
          ' ' + inbndTrainETA.substring(11, 13) + ':' + inbndTrainETA.substring(14, 16);
      }
    }
    return inbndTrainETA;
  }

  /**
   * Retrieve filtered array of loco object based on type. like TRAIN, TERMINAL
   * @param {Array<TerminalHandlingLocoInfo>} locoInfoList
   * @param {string} type
   * @returns {Array<TerminalHandlingLocoInfo>}
   * @memberOf LmsTerminalHandlingComponent
   */
  getFilteredLocoObjArr(locoInfoList: Array<TerminalHandlingLocoInfo>, type: string): Array<TerminalHandlingLocoInfo> {
    const thpFilteredLocoArray: Array<TerminalHandlingLocoInfo> = locoInfoList.filter(
      (terminalHandlingLocoInfo) => {
        return ((terminalHandlingLocoInfo.currAssignText) &&
          (terminalHandlingLocoInfo.currAssignText.trim().toUpperCase() === type));
      }
    );
    return thpFilteredLocoArray;
  }

  /**
   * Clean error mesasges.
   * @param {any} event
   * @memberOf LmsTerminalHandlingComponent
   */
  clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.handling.message = '';
    this.updateTab(this.selectedTab);
  }

  /**
   * Destroy the lifecycle hook.
   * @memberOf LmsTerminalHandlingComponent
   */
  ngOnDestroy() {
    super.destroy();
    if (this.popupServiceSubscription) {
      this.popupServiceSubscription.unsubscribe();
    }
    if (this.terminalHandlingSub) {
      this.terminalHandlingSub.unsubscribe();
    }
  }

  /**
   * Download Excel value
   * @memberof LmsTerminalHandlingComponent
   */
  submiExceltAction() {
    const terminalHandlingOnTerminals: Array<TerminalHandlingOnTerminal> = [];
    if (this.totalOnTerminalLocomotivesArr) {
      for (let i = 0; i < this.totalOnTerminalLocomotivesArr.length; i++) {
        for (let j = 0; j < this.totalOnTerminalLocomotivesArr[i].locomotiveArr.length; j++) {
          const terminalHandlingOnTerminal = {
            previousAssignment: this.totalOnTerminalLocomotivesArr[i].previousAssignment,
            locomotiveId: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].locomotiveId,
            thpTypeCode: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].thpTypeCode,
            terminalHandlingPlan: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].terminalHandlingPlan,
            changedBy: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].changedBy,
            userName: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].userName,
            actualActivityDesc: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].actualActivityDesc,
            actualActivityTs: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].actualActivityTs,
            plannedAssignment: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].plannedAssignment,
            projectedDeparture: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].projectedDeparture,
            previousPlan: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].previousPlan,
            actualLocomotiveId: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].actualLocomotiveId,
            intendedUsageCode: this.totalOnTerminalLocomotivesArr[i].locomotiveArr[j].intendedUsageCode,
          };
          terminalHandlingOnTerminals.push(terminalHandlingOnTerminal);
        }
      }
    }
    const terminalHandlingExcel = {
      terminalHandlingInboundArr: this.terminalHandlingInbounds,
      terminalHandlingOnTerminaldArr: terminalHandlingOnTerminals
    };
    this.terminalHandlingService.excelDownload(terminalHandlingExcel).subscribe(
      (blob) => {
          const link = document.createElement('a');
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.setAttribute('download', 'TerminalHandlingPlan');
          link.click();
          link.remove();
      }, error => {
        this.lmsLoggerService.logInfo('LmsTerminalHandlingComponent => submiExceltAction', 'Error downloading the file.');
      });
  }

  showContextLinksMenu(event: any, panel: OverlayPanel) {
    if (!this.overlayPanel) {
      this.overlayPanel = panel;
    }
    this.setOverlayLinks(event.type);
    setTimeout(() => {
      this.locomotiveOverlayPosition(event.event, event.id);
    }, 20);
    this.contextMenuType = event.type;
    this.contextMenuValue = event.value;
    const page = document.getElementById('terminalHandlingPage');
    if (page) {
      const clickEvent = this.checkForOverlayPanelVisibility.bind(this);
      page.addEventListener('click', clickEvent);
    }

  }

  checkForOverlayPanelVisibility() {
    if (this.overlayPanel) {
      this.overlayPanel.hide();
      this.hideContextMenuChild();
    }
    this.overlayLinks = null;
    this.contextMenuType = null;
    this.contextMenuValue = null;
    const page = document.getElementById('terminalHandlingPage');
    if (page) {
      const clickEvent = this.checkForOverlayPanelVisibility.bind(this);
      page.removeEventListener('click', clickEvent);
    }
  }

  setOverlayLinks(type: string) {
    this.checkForOverlayPanelVisibility();
    if (type === 'Terminal') {
      this.overlayLinks = this.terminalLinks;
    } else if (type === 'Train') {
      this.overlayLinks = this.trainLinks;
    }
  }

  public locomotiveOverlayPosition(event, id) {
    if (!this.overlayPanel.overlayVisible && this.panelVisible === true) {
      this.panelVisible = false;
    }
    if (this.panelVisible) {
      this.overlayPanel.hide();
      this.panelVisible = false;
      event.stopPropagation();
      return;
    }
    const overlayPanel = document.getElementById('handlingMenuLinksPanel').getElementsByClassName('p-overlaypanel');
    const element = event.target.parentElement;
    // if (!element && event.target && event.target.parentElement) {
    //   element = event.target.parentElement;
    // }
    this.overlayPanel.show(event);
    const rect = element.getBoundingClientRect();
    const scrollHeight = window.pageYOffset;
    const windowHeight = window.innerHeight;
    let overlayHeight = 0;
    if (this.overlayLinks && this.overlayLinks.length > 0) {
      overlayHeight = this.overlayLinks.length * 30;
    } else {
      this.overlayPanel.hide();
      return;
    }
    let top;
    if ((windowHeight - rect.top - rect.height) > overlayHeight) {
      top = rect.top + rect.height + scrollHeight + 'px';
    } else {
      top = (rect.top - overlayHeight) + scrollHeight + 'px';
    }
    const left = rect.left + 'px';
    const width = rect.width + 'px';
    let style = `display: block; z-index: 1001; visibility: visible;
            opacity: 1.032; top: <<top>>; left: <<left>>; width: <<width>>;`;
    style = style.replace('<<top>>', top);
    style = style.replace('<<left>>', left);
    style = style.replace('<<width>>', width);
    overlayPanel[0].setAttribute('style', style);
    event.stopPropagation();
    this.panelVisible = true;
  }

  public routeToPage(subType: string, type: string, searchText: string) {
    // Story #6 - Code to open Train Data in new window
    if (type === 'Train') {
      const tabSearchParameter = <TabSearchParameter>({ searchText: searchText });
      window.open(
        window.location.href.split('?')[0] + '?type=train&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
        '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
      );
    } else {
      const tabSearchParameter = <TabSearchParameter>({ searchText: this.appUtilityService.UIformatLocomotiveId(searchText) });

    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
    }
  }
}
